import { postAxios } from "services/api/api.service";
import { timeMapping } from "./TrainsIncidents.util";
import { apiNames } from "services/api/endpoint.service";

import * as mocks from "./TrainsIncidents.mock";

/**
 * @description llamada a viajes
 * @param query 
 * @param callback 
 * @param errorCallback 
 * @param mock 
 */
export function sheduleInformationCall(query: any, callback: Function, errorCallback: Function,  mock: string) {

    if (mock === "true") {
       const mock = mocks.getSheduleInformation();
      //const mock = mocks.getTier();
      try {
        sessionStorage.setItem('raas-trip-mock-data', JSON.stringify(mock));
      } catch (error) {
        sessionStorage.setItem('raas-trip-mock-data', 'error saving mock');
      }
      callback(mock);
    } else {
      let body={
        //context:query.context,
        originID: query.originID,
        destinationID: query.destinationID,
        tripDate:query.tripDate,
        timeEndRange: "23:59",
        timeStartRange:timeMapping(query)
      }
      postAxios(apiNames.BKING, false, "/schedule-information/v2",body).then((data: any) => {
        callback(data);
      }).catch((error: any) => {
        errorCallback(error)
      })
    }
  }
  
 /**
 * @description llamada a viajes
 * @param query 
 * @param callback 
 * @param errorCallback 
 * @param mock 
 */
// Adaptación de la función para usar async/await y devolver un valor
export function getConsultIncidence(query: any, callback: Function, errorCallback: Function,  mock: string){

  if (mock === "true") {
    const mock = mocks.getConsultIncidence();
   //const mock = mocks.getTier();
   try {
     sessionStorage.setItem('raas-trip-mock-data', JSON.stringify(mock));
   } catch (error) {
     sessionStorage.setItem('raas-trip-mock-data', 'error saving mock');
   }
   callback(mock.data);
 } else {
    // Si no es mock, realizar la llamada al backend
    const body = {
     nucleo: query.nucleo,
    date: query.date
      //id:id
    };

    postAxios(apiNames.BKING, false, "/consult-incidence/v2",body).then((data: any) => {
      callback(data.data);
    }).catch((error: any) => {
      errorCallback(error)
    })
  }
}

 





export interface ITrainsIncidents {
  nucleo:     string;
  descNucleo: string;
  aviso:      Aviso[];
}

export interface Aviso {
  inicio:    Date;
  lineas:    null | string;
  sublineas: null | string;
  texto:     string;
}
